<template>
    <div>
        <sub-menu-faturamento ativo="notas-fiscais" v-if="is_faturamento"></sub-menu-faturamento>

        <div class="card dashcard mb-0">
            <div class="card-body">
                <div class="form-row">
                    <div class="col col-12 col-md-6">
                        <az-periodo
                            v-model="filtro"
                            :sync="true"
                            @sync="load()"
                        />
                    </div>
                    <div
                        class="col col-12 col-md-4"
                        v-if="$store.state.unidade.unidade_operacaos.length > 1"
                    >
                        <az-input
                            icon="far fa-building fa-fw"
                            type="select"
                            placeholder="Todas as unidades"
                            :optionsList="$util.unidades_com_tags(true, true)"
                            optionsData="id_unidade_operacao"
                            v-model="id_unidade_operacao"
                        />
                    </div>
                    <div class="col col-12 col-md-2">
                        <az-input
                            type="select"
                            icon="fa fa-filter"
                            optionsData="id"
                            :optionsList="[
                                { id: '0', search: 'Todos' },
                                { id: '1', search: 'Gerada' },
                                { id: '2', search: 'Aguardando processamento' },
                                { id: '3', search: 'Processado com Erro' },
                                { id: '4', search: 'Emitida' },
                                { id: '5', search: 'Cancelada' }
                            ]"
                            v-model="filtro.status"
                        />
                    </div>
                </div>
                <div class="form-row mt-3">
                    <div class="col col-12 col-md-12">
                        <az-input
                            icon="fa fa-search fa-fw"
                            placeholder="Digite N + Número para buscar pela NF ou R + Número para buscar pelo RPS..."
                            v-model="filtro.search"
                        >
                            <template v-slot:buttonposb>
                                <div class="input-group-append">
                                    <button
                                        class="btn btn-outline-primary"
                                        type="button"
                                        @click="emitirNFAvulsa()"
                                    >
                                        <i
                                            class="fa fa-plus"
                                            aria-hidden="true"
                                        ></i> Emitir Nota Avulsa
                                    </button>
                                    <button
                                        class="btn btn-outline-success mx-2"
                                        type="button"
                                        @click="emitirNFLote()"
                                    >
                                        <i
                                            class="fas fa-wifi"
                                            aria-hidden="true"
                                        ></i> Emitir Nfs em Lote
                                    </button>
                                    <button
                                        class="btn btn-outline-info mx-2"
                                        type="button"
                                        @click="consultarNFLote()"
                                    >
                                        <i
                                            class="fas fa-wifi"
                                            aria-hidden="true"
                                        ></i> Consultar Nfs em Lote
                                    </button>

                                    <print-export printid="lista-lancamentos" :dados="dadosFormatados" :left="true" />
                                </div>
                            </template>
                        </az-input>
                    </div>
                </div>
            </div>
        </div>

        <div class="progress mt-1 mb-2">
            <div
                class="indeterminate"
                v-if="$store.state.loading && dados"
            ></div>
            <div class="determinate" v-else></div>
        </div>

        <template v-if="!lista || !lista.length">
            <az-empty-state />
        </template>

        <div id="lista-lancamentos" v-if="dados && lista.length">

            <cabecalho-generico titulo="Notas Fiscais">
            </cabecalho-generico>

            <div class="card-deck">
                <div class="card" v-for="(valor, ivx) in total_por_status" :key="ivx">
                    <div class="card-body d-flex justify-content-between py-2" :class="getStatusClass(valor.chave)">
                        <div>
                            <a href="#" @click.prevent="filtrar(valor.descricao)" class="card-link">
                                {{ valor.descricao }}
                            </a>
                        </div>
                        <div>{{ $util.formatMoeda(valor.total) }}</div>
                    </div>
                </div>
            </div>

            <table class="table table-hover table-responsive-md bg-white mt-3 small cabecalho-fixo">
                <thead>
                    <tr>
                        <th class="text-center">
                            <button type="button" class="btn btn-outline-primary btn-sm d-print-none" @click="marcar_todos()" v-if="pode_marcar_todos">
                                Todos
                            </button>
                        </th>
                        <th>Emissão</th>
                        <th>Número</th>
                        <th>RPS</th>
                        <th>Unidade</th>
                        <th>Status</th>
                        <th>{{ is_faturamento ? 'Operadora' : 'Operadora/Paciente' }}</th>
                        <th v-if="!is_faturamento">Atendimento</th>
                        <th class="text-right">Valor</th>
                        <th>Ações</th>
                        <th v-if="is_faturamento" class="text-right">Saldo Créditos</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(nf, idx) in lista" :key="idx">
                        <td class="text-center">
                            <template v-if="nf.ch_status == '1' || nf.ch_status == '2'">
                                <input class="form-check-input ml-0" type="checkbox" v-model="nf.expanded" id="defaultCheck1">
                            </template>
                        </td>
                        <td>
                            {{ $util.getFormatDate(nf.dt_emissao) }}
                        </td>
                        <td>
                            {{ nf.numero_completo }}
                        </td>
                        <td>
                            {{ nf.st_numero }}
                            <span class="small" v-if="nf.dt_emissao && nf.created_at && nf.created_at.substr(0,10) != nf.dt_emissao.substr(0,10)">
                                / 
                                {{ $util.getFormatDate(nf.created_at) }}
                            </span>
                        </td>
                        <td>
                            <span v-if="nf.unidade_operacao" :title="nf.unidade_operacao.st_nome">
                                {{ nf.unidade_operacao.st_sigla }}
                            </span>
                        </td>
                        <td :class="getStatusClass(nf.ch_status)">
                            {{ nf.descricao_status }}
                        </td>
                        <td>
                            <div class="d-flex justify-content-between">
                                <div>
                                    {{ nf.tomador }}
                                </div>
                                <div v-if="nf.paciente">
                                    <a href="#" @click.prevent="$root.perfil(nf.paciente)" class="card-link">
                                        <i class="fas fa-id-badge" aria-hidden="true"></i>
                                    </a>
                                </div>
                            </div>
                        </td>
                        <td v-if="!is_faturamento">
                            <template v-if="nf.nota_fiscal_servico_link">
                                <div v-for="(link, ilx) in nf.nota_fiscal_servico_link" :key="ilx">
                                    <a href="#" @click.prevent="abrir_atendimento(link.model.id_atendimento)" v-if="link.model.id_atendimento" class="card-link">
                                        #{{ link.model.id_atendimento }}
                                    </a>

                                    <a href="#" @click.prevent="$util.abrirPagamentos(nf)" v-else-if="link.model.id_pagamento_atendimento" class="card-link">
                                        Pag: {{ link.model.id_pagamento_atendimento }}
                                    </a>
                                </div>
                            </template>

                            <pre v-if="false">{{ nf.nota_fiscal_servico_link }}</pre>
                        </td>
                        <th class="text-right">
                            {{ $util.formatMoeda(nf.dc_valor_liquido_nfse) }}
                        </th>
                        <td class="text-nowrap">
                            <nota-fiscal-status
                                id="nfStatus"
                                :left="true"
                                :exibirEditar="true"
                                :notaFiscal="nf"
                                exibir_cancelar_manual="true"
                                @refresh="load()"
                            />
                        </td>
                        <td class="text-right" v-if="is_faturamento">{{ $util.formatMoeda(nf.saldo_credito) }}
                            <div class="text-right" v-if="nf.creditos && nf.creditos.length">
                                <div v-for="(cred, icx) in nf.creditos" :key="icx">
                                    <a href="#" @click.prevent="$util.abrirFatura(cred.id_fatura)" class="card-link ml-2">
                                        #{{ cred.id_fatura }} / {{ $util.formatMoeda(cred.dc_valor) }}
                                    </a>
                                </div>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <!-- Paginação -->
        <nav class="navbar fixed-bottom navbar-light bg-light pb-3" v-if="dados && dados.last_page > 1">
            <div class="d-flex">
                <paginate
                    class="mb-0"
                    :page-count="dados.last_page"
                    :container-class="'pagination'"
                    :page-class="'page-item'"
                    :page-link-class="'page-link'"
                    :prev-class="'page-link'"
                    :next-class="'page-link'"
                    :prev-text="'<<'"
                    :next-text="'>>'"
                    :click-handler="paginar">
                </paginate>
            </div>
        </nav>

        <!-- Nota Fiscal Geração -->
        <nota-fiscal-geracao id="notaFsicalGeracao" ref="notaFiscalGeracaoRef" @refresh="load()" @refresh_gerar="load()"></nota-fiscal-geracao>

        <!-- Dispatch -->
        <az-dispatch ref="dispatchModal" titulo="Emitir Nfs em Lote" @refresh="load()" />

    </div>
</template>

<script>
import _ from "lodash";
import * as moment from "moment";
import AzInput from "../../shared/forms/AzInput.vue";
import AzEmptyState from "../../util/AzEmptyState.vue";
import NotaFiscalStatus from "./NotaFiscalStatus.vue";
import AzPeriodo from "../../shared/forms/AzPeriodo.vue";
import NotaFiscalGeracao from "./NotaFiscalGeracao.vue";
import AzDispatch from "../../util/AzDispatch.vue";
import PrintExport from '../../shared/PrintExport.vue';
import CabecalhoGenerico from '../../relatorios/shared/CabecalhoGenerico.vue';
import SubMenuFaturamento from '../faturamento/SubMenuFaturamento.vue';
// import AzSubmit from '../../util/AzSubmit.vue';

export default {
    data() {
        return {
            dados: null,
            referencia: this.$util.hoje().substr(0, 7),
            id_unidade_operacao: "",
            filtro: {
                search: "",
                status: "0",
                periodo: "m",
                inicio: "",
                fim: ""
            },
            page: 1,
        };
    },

    components: {
        AzInput,
        AzEmptyState,
        NotaFiscalStatus,
        AzPeriodo,
        NotaFiscalGeracao,
        AzDispatch,
        PrintExport, 
        CabecalhoGenerico,
        SubMenuFaturamento, 
    },

    computed: {
        is_faturamento: function () { 
            return this.$route.path.slice(0,12) == '/faturamento' ? true : false;
        },

        total_por_status: function () { 
            return _.map(
                _.groupBy(
                    this.lista, 
                    'ch_status'
                ), (lista, chave) => {
                    return {
                        chave: chave,
                        descricao: lista[0].descricao_status,
                        total: _.sumBy(lista, item => parseFloat(item.dc_valor_liquido_nfse))
                    }
                });
        },

        nfs_selecionadas: function () {
            return this.lista.filter(item => item.expanded);
        },

         pode_marcar_todos: function () {
            return this.lista.filter(item => item.ch_status == '1').length > 0;
        },

        dadosFormatados: function() {
            return this.lista.map(nf => {
                return {
                    data: this.$util.getFormatDate(nf.dt_emissao),
                    numero: nf.numero_completo, 
                    rps: nf.st_numero, 
                    unidade: nf.unidade_operacao ? nf.unidade_operacao.st_sigla : '',
                    status: nf.descricao_status, 
                    tomador: nf.tomador, 
                    link: nf.nota_fiscal_servico_link 
                            ? nf.nota_fiscal_servico_link.map(link => { 
                                    return ( link.model && link.model.id_atendimento ) 
                                        ? '#' + link.model.id_atendimento 
                                        : ( link.model.id_pagamento_atendimento ? 'Pag: ' + link.model.id_pagamento_atendimento : '' );
                                })
                                .filter(link => link)
                                .join(', ')
                            : '', 
                    valor: this.$util.formatMoeda(nf.dc_valor_liquido_nfse)
                };
            });
        },

        status: function() {
            return this.filtro.status;
        },

        lista: function() {
            if (!this.dados) return [];

            let reg = this.$util.getregex(this.filtro.search);

            return _.orderBy(
                this.dados.data.filter(item => {
                    return (
                        !this.filtro.search || reg.test(JSON.stringify(item))
                    );
                }),
                "st_numero"
            );
        },

        total: function() {
            return _.sumBy(this.lista, "dc_valor");
        },

        selecionados: function() {
            return this.lista.filter(item => item.selecionado);
        },

        total_selecionado: function() {
            return this.selecionados.reduce((total, item) => {
                return (total = total + item.dc_valor);
            }, 0);
        }
    },

    methods: {
        filtrar (texto) {
			if ( this.filtro.search == '"' + texto + '"' ) {
                this.filtro.search = "";
            } else {
                this.filtro.search = '"' + texto + '"';
            }
        },

        marcar_todos() {
             _.each(this.lista.filter(item => item.ch_status == '1'), item => {
                item.expanded = !item.expanded;
            });
        },

        abrir_atendimento (id) {
            this.$util.abrir_atendimento(this, id);
        },

        paginar (page) {
            this.page = page;
            this.load();
        },
        marcar_itens(lista, marcado) {
            _.each(lista, item => {
                item.selecionado = !marcado;
            });
        },

        ajustar_fim() {
            if (this.from) this.to = this.from;
        },

        load() {
            if (this.referencia) {
                if (!this.from || !this.to || this.from > this.to) {
                    this.dados = null;
                    return;
                }
            }

            this.$util.load(this, {
                service: "nota_fiscal_servico",
                parms: {
                    referencia: this.referencia,
                    from: this.from,
                    to: this.to,
                    id_unidade_operacao: this.id_unidade_operacao,
                    ...this.filtro,
                    page: this.page,
                    size: 100,
                    faturamento: this.is_faturamento, 
                },
                loadTo: res => {
                    this.dados = res;
                }
            });
        },

        getStatusClass(status) {
            switch (status) {
                case "1":
                    return "text-info";
                case "2":
                    return "text-primary";
                case "3":
                    return "text-warning";
                case "4":
                    return "text-success";
                case "5":
                    return "text-danger";

                default:
                    return "text-info";
            }
        },

        emitirNFAvulsa() {

            this.$refs.notaFiscalGeracaoRef.emitirNotaFiscalAavulso();

        },

        emitirNFLote() {
            // let nfs = new Array();

            // if(this.nfs_selecionadas.length <= 0) {
            //     this.$toast.add({
            //         severity: "error",
            //         summary: "Atenção",
            //         detail: 'Não existem Notas Fiscais com o status "Gerada" nos itens selecionados',
            //         life: 3000
            //     });

            //     return;
            // }

            // this.nfs_selecionadas.forEach(nfl => {
            //     nfs.push({id_nota_fiscal_servico: nfl.id_nota_fiscal_servico})
            // });

            // this.$refs.dispatchModal.executar_chunck(
            //     "nota_fiscal_servico",
            //     "emitir_nota_fiscal",
            //     nfs,
            //     '',
            //     {},
            //     1
            // );

            let nfs = new Array();

            if(this.nfs_selecionadas && Array.isArray(this.nfs_selecionadas)) {
                this.nfs_selecionadas.forEach((nfl) => {
                    if(nfl && nfl.ch_status && nfl.ch_status == '1') {
                        nfs.push(nfl.id_nota_fiscal_servico);
                    }
                });
            }

            if(nfs.length <= 0) {
                this.$toast.add({
                    severity: "error",
                    summary: "Atenção",
                    detail: 'Não existem Notas Fiscais com o status "Gerada" nos itens selecionados',
                    life: 3000
                });

                return;
            }

            if (!confirm("Deseja realmente emitir as Notas Fiscais selecionadas?")) {
                return;
            }

            this.$util.atualizar(this, {
                service: 'nota_fiscal_servico',
                func: 'emitir_notas_lote',
                redir_api: true,
                dados: {
                    ids: nfs
                },
                callback: () => {
                    this.load();
                }
            });
        },
        
        consultarNFLote() {
            let nfs = new Array();

            if(this.nfs_selecionadas && Array.isArray(this.nfs_selecionadas)) {
                this.nfs_selecionadas.forEach((nfl) => {
                    if(nfl && nfl.ch_status && nfl.ch_status == '2') {
                        nfs.push(nfl.id_nota_fiscal_servico);
                    }
                });
            }

            if(nfs.length <= 0) {
                this.$toast.add({
                    severity: "error",
                    summary: "Atenção",
                    detail: 'Não existem Notas Fiscais com o status "Aguardando processamento" nos itens selecionados',
                    life: 3000
                });

                return;
            }

            if (!confirm("Deseja realmente consultar as Notas Fiscais selecionadas?")) {
                return;
            }

            this.$util.atualizar(this, {
                service: 'nota_fiscal_servico',
                func: 'emitir_notas_lote',
                redir_api: true,
                dados: {
                    ids: nfs,
                    consultar: true
                },
                callback: () => {
                    this.load();
                }
            });
        }
    },

    created() {
        if (this.referencia) {
            this.from = this.referencia + "-01";
            this.to = moment(this.referencia + "-01")
                .endOf("month")
                .format("YYYY-MM-DD");
        }
    },

    mounted() {
        if ( this.is_faturamento ) { 
            this.$store.commit("setBreadcrumb", [
                { name: "Faturamento", path: "/faturamento/guias" },
                { name: "Notas Fiscais", path: "/faturamento/notas-fiscais" }
            ]);
        } else { 
            this.$store.commit("setBreadcrumb", [
                { name: "Financeiro", path: "/financeiro" },
                { name: "Notas Fiscais", path: "/financeiro/notas-fiscais" }
            ]);
        }

        this.$nextTick(() => {
            this.load();
        });
    }
};
</script>

